import { Component, Inject, OnInit } from "@angular/core";
import { Services } from "../../shared/services";

@Component({
    selector: 'app-acesso-gov-br-bronze',
    templateUrl: './acesso-gov-br-bronze.component.html',
    styleUrls: ['./acesso-gov-br-bronze.component.scss']
})
export class AcessoGovBrBronzeComponent implements OnInit {

    constructor(protected svc: Services)
    {
    }

    ngOnInit(): void
    {
      this.svc.acessoExternoService.realizarLogoutGovBr(null);
    }
}
